import { COUNTRIES } from '@core/actionNames';
const { SET_DATA, SET_CURRENT } = COUNTRIES;

export function setCurrent(countryCode) {
    return (dispatch, getState) => {
        if (getState().countries.current !== countryCode) {
            dispatch({
                type: SET_CURRENT,
                countryCode,
            });
        }
    };
}

export function setData(data) {
    return {
        type: SET_DATA,
        data,
    };
}
